import { Button } from '@napaicp/ui'
import { Moon, Sun } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { applyTheme, persistTheme, resolveInitialTheme, type Theme } from '@/lib/theme'

/**
 * Light/dark toggle for global navigation, matching `LanguageSwitcher`'s
 * footprint. `packages/ui`'s components already ship a full dark palette and
 * `dark:` variants — this is what actually turns it on.
 */
export function ThemeToggle() {
  const { t } = useTranslation('nav')
  const [theme, setTheme] = useState<Theme>(() => resolveInitialTheme())

  function toggle(): void {
    const next: Theme = theme === 'dark' ? 'light' : 'dark'
    setTheme(next)
    persistTheme(next)
    applyTheme(next)
  }

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      aria-label={theme === 'dark' ? t('theme.switchToLight') : t('theme.switchToDark')}
      className="px-2"
      onClick={toggle}
    >
      {theme === 'dark' ? (
        <Sun className="size-4" aria-hidden="true" />
      ) : (
        <Moon className="size-4" aria-hidden="true" />
      )}
    </Button>
  )
}
